import { datadogRum } from '@datadog/browser-rum';

export function setDataDogQuotingApplicationIdContext(quotingApplicationId: string | undefined) {
  datadogRum.addRumGlobalContext('quotingApplicationId', quotingApplicationId);
}
